import { createSlice } from '@reduxjs/toolkit';

const INIT_STATE = {
  otherUserId: undefined,
  conversationId: undefined,
  isIncoming: false,
  isOutgoing: false,
  isCalling: false,
  getCalled: false,
  muted: false,
  screenShared: false,
  videoOff: false,
  recording: false,
  recordLoading: false,
  otherUser: {
    videoOff: false,
    audioOff: false,
    screenShared: false
  }
};

const { actions, reducer } = createSlice({
  name: 'call',
  initialState: INIT_STATE,
  reducers: {
    setOtherUserId: (state, { payload }) => {
      state.otherUserId = payload;
    },
    setConversationId: (state, { payload }) => {
      state.conversationId = payload;
    },
    setIsIncoming: (state, { payload }) => {
      state.isIncoming = payload;
    },
    setIsCalling: (state, { payload }) => {
      state.isCalling = payload;
    },
    setGetCalled: (state, { payload }) => {
      state.getCalled = payload;
    },
    setIsOutgoing: (state, { payload }) => {
      state.getCalled = payload;
    },
    setMuted: (state, { payload }) => {
      state.muted = payload;
    },
    setVideoOff: (state, { payload }) => {
      state.videoOff = payload;
    },
    setScreenShared: (state, { payload }) => {
      state.screenShared = payload;
    },
    setRecording: (state, { payload }) => {
      state.recording = payload;
    },
    setRecordLoading: (state, { payload }) => {
      state.recordLoading = payload;
    },
    setOtherUserVideoOff: (state, { payload }) => {
      state.otherUser.videoOff = payload;
    },
    setOtherUserScreenShared: (state, { payload }) => {
      state.otherUser.screenShared = payload;
    },
    resetCall: () => INIT_STATE
  }
});

export const {
  setOtherUserId,
  setIsIncoming,
  setIsCalling,
  setGetCalled,
  setIsOutgoing,
  setMuted,
  setScreenShared,
  setVideoOff,
  setRecording,
  setRecordLoading,
  resetCall,
  setConversationId,
  setOtherUserVideoOff,
  setOtherUserScreenShared
} = actions;

export default reducer;
